<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="20"
    navigation
    :breakpoints="breakpoints"
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    :class="{ overflow: list.length > 3 }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <a :href="item.url">
        <figure><img :src="item.pic" :alt="item.title"></figure>
        <dl class="description">
          <dt v-html="item.title"></dt>
          <dd class="param" v-if="item.param" v-html="item.param"></dd>
          <dd class="elem" v-if="item.elem" v-html="item.elem"></dd>
        </dl>
        <p v-html="item.text"></p>
      </a>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide {
  height: auto;
}

// Swiper 初期化前・画像ロード前からレイアウトを確保。
// 本番利用例: /purpose/ の i_0X.jpg が 500x300 (5:3)。
figure {
  aspect-ratio: 500 / 300;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    aspect-ratio: 500 / 300;
    object-fit: cover;
    display: block;
  }
}

// grabカーソルを適用
.swiper-scrollbar {
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
}

.param {
  background: module.$main;
  padding: .1rem 1rem;
  display: inline-block;
  color: module.$white;
  border-radius: .24rem;
  margin: .4rem 0;
}

.elem {
  position: relative;
  padding: 0 0 0 1.1rem;
  margin: .4rem 0 0;
  &:before {
    content: '';
    width: .8rem;
    height: .8rem;
    border: module.$main 3px solid;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const breakpoints = {
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    };

    const onSwiper = (swiper) => {
      // swiper本体を取得できる（必要ならここで操作）
    }
    const onSlideChange = () => {
      // スライド変更時の処理
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
      breakpoints
    }
  },
}
</script>
